// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.availability-chart {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.availability-chart .p-chart-legend li {
  display: flex;
  flex-direction: column; /* Stack label and percentage */
  align-items: center; /* Center-align legend text */
  margin-right: 20px; /* Add space between legends */
  font-size: 12px; /* Adjust legend font size */
  line-height: 1.5; /* Spacing between label and percentage */
}
.availability-chart .p-chart-legend .p-legend-icon {
  border-radius: 50%; /* Ensure circular legend dots */
  margin-bottom: 5px; /* Add space below the dot */
}
.availability-chart .p-calendar {
  width: 100px;
  min-width: 10rem;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/availablility-chart/availablility-chart.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;AACJ;AAAI;EACI,aAAA;EACA,sBAAA,EAAA,+BAAA;EACA,mBAAA,EAAA,6BAAA;EACA,kBAAA,EAAA,8BAAA;EACA,eAAA,EAAA,4BAAA;EACA,gBAAA,EAAA,yCAAA;AAER;AACI;EACI,kBAAA,EAAA,gCAAA;EACA,kBAAA,EAAA,4BAAA;AACR;AACI;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;AACR","sourcesContent":[".availability-chart{\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    .p-chart-legend li {\n        display: flex;\n        flex-direction: column; /* Stack label and percentage */\n        align-items: center; /* Center-align legend text */\n        margin-right: 20px; /* Add space between legends */\n        font-size: 12px; /* Adjust legend font size */\n        line-height: 1.5; /* Spacing between label and percentage */\n    }\n    \n    .p-chart-legend .p-legend-icon {\n        border-radius: 50%; /* Ensure circular legend dots */\n        margin-bottom: 5px; /* Add space below the dot */\n    }\n    .p-calendar{\n        width:100px;\n        min-width: 10rem;\n        border-radius: 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
